<template>
  <div>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          fab
          color="info"
          x-small
          depressed
          @click="isOpen = true"
        >
          <v-icon
            small
          >
            mdi-silverware-fork-knife
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('combos.modals.attach.title') }}</span>
    </v-tooltip>

    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Enviar {{ combo.name }} al menu</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="attachCombo" v-model="form.valid">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    :label="$t('combos.labels.internalId')"
                    :rules="combo.validation().internalId"
                    v-model="form.data.internalId">
                  </v-text-field>
                  <v-text-field
                    :label="$t('combos.labels.name')"
                    v-model="form.data.name"
                    :rules="combo.validation().name"
                    required>
                  </v-text-field>
                  <v-text-field
                    :label="$t('combos.labels.price')"
                    :rules="combo.validation().price"
                    v-model.number="form.data.price">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="closeDialog">
            {{ $t('combos.actions.close') }}
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="submit">
            {{ $t('combos.actions.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import Combo from '@/models/Combo'

export default {
  name: 'AttachCombo',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    let combo = new Combo(this.item.$)

    return {
      isOpen: false,
      overlay: false,
      combo,
      form: {
        valid: false,
        data: {}
      }
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.setInitialCombo()
      }
    }
  },
  methods: {
    submit: async function () {
      this.$refs.attachCombo.validate()

      if (this.form.valid) {
        this.combo.set(this.form.data)
        this.overlay = true
        try {
          await this.combo.save()
          await this.combo.updateStatus({ status: 'attached' })
          this.$emit('updated', this.combo)
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    setInitialCombo () {
      this.resetComboForm()
      this.form.data = cloneDeep(this.item.$)
    },
    resetComboForm () {
      if (this.$refs.attachCombo) this.$refs.attachCombo.reset()
      this.form.data = {}
    },
    closeDialog () {
      this.isOpen = false
      this.resetComboForm()
      this.$emit('close', false)
    }
  }
}
</script>
